// @flow
import React from 'react'
import AbstractFormField from './AbstractFormField'
import { Popover } from '../../../Components/'
import { Bool } from '../../../Components/_formFields'
import type { AssociatedFieldType } from '../../Types/ProductContent'
import type { DefaultFormFieldType } from './AbstractFormField'
import type { InputHelpsType, InputHelpType } from '../../Types/InputHelpType'
import isMobile from 'is-mobile'

type CheckboxAssociationTwoColumnsPropsType = DefaultFormFieldType & {
  associatedField: AssociatedFieldType,
  name: string,
  inputHelps: InputHelpsType,
  label: string,
  parent: string,
}
export default class CheckboxAssociationTwoColumns extends AbstractFormField<CheckboxAssociationTwoColumnsPropsType> {

  handleOnchange = (checked: boolean, name: string) => {
    this.props.onChange(checked, name)
  }

  handleRenderOneItem = (domain: Object, prefix: string, item: Object, formData: Object, associatedField: Object,
                         inputHelp: InputHelpType | null, readOnly: boolean = false, onBlur?: Function) => (
    <div className='row mt-3' key={`${prefix}-${item.name}`}>
      <div className='col-10'>
        <Bool
          domain={domain}
          enabled={!readOnly}
          id={`${prefix}-${item.name}`}
          key={`${prefix}-${item.name}`}
          label={associatedField.labels[item.name]}
          onBlur={onBlur}
          onChange={(checked) => {
            this.handleOnchange(checked, item.name)
          }}
          value={formData && !!formData[item.name]}
        />
      </div>
      <div className={`col-2 ${isMobile() ? 'text-right' : 'text-left'}`}>
        {inputHelp &&
        <Popover
          content={inputHelp.content}
          id={`ID${item.id ? `${item.id}-` : ''}${prefix}${item.name}`}
          templateVariables={{}}
          title={inputHelp.title}
        />
        }
      </div>
    </div>
  )

  render() {
    const { associatedField, prefix, formData, domain, inputHelps, label, parent, name, onBlur } = this.props

    if (!associatedField || !associatedField.items) {
      return null
    }

    let items = associatedField.items.filter((item) => item.enabled)

    if (!items.length) {
      return null
    }

    const breakPoint = Math.ceil(items.length / 2) - 1

    return ([
      <div className='col-12' key='checkboxAssociation-title'>
        <label className='mb-0 mr-4 font-weight-bold'>{label}</label>
        {!!inputHelps[parent] &&
          <Popover
            content={inputHelps[parent].content}
            id={`ID${parent ? `${parent}-` : ''}${prefix}${name}`}
            templateVariables={{}}
            title={inputHelps[parent].title}
          />
        }
      </div>,
      <div className='row mt-2 px-sm-3' key='checkboxAssociation-column-1'>
        <div className='col-sm-6'>
          {items.map((item, index) =>
            index <= breakPoint
              ? this.handleRenderOneItem(domain, prefix, item, formData, associatedField,
              inputHelps[item.name] && inputHelps[item.name].content ? inputHelps[item.name] : null, !!associatedField.readOnly, onBlur)
              : null
          )}
        </div>
        <div className='col-sm-6'>
          {items.map((item, index) =>
            index > breakPoint
              ? this.handleRenderOneItem(domain, prefix, item, formData, associatedField,
              inputHelps[item.name] && inputHelps[item.name].content ? inputHelps[item.name] : null, !!associatedField.readOnly, onBlur)
              : null
          )}
        </div>
      </div>
    ])
  }
}
